import React from 'react';
import HeaderComponents from '../components/header.components';

export default function HeaderContainer() {
  return <HeaderComponents />;
}
